import { render, staticRenderFns } from "./BegruendeteAbweichungen.vue?vue&type=template&id=53ae5dc2"
import script from "./BegruendeteAbweichungen.vue?vue&type=script&lang=js"
export * from "./BegruendeteAbweichungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports